export default __webpack_public_path__ + "static/large-headings-do-abbc1847a047b29aab87673c63e3231e8c5d265cb221c5d419881e83766232ef.png";